"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var fetchJsonp = require("fetch-jsonp");
var OEmbedLoader = (function () {
    function OEmbedLoader(cssSelector, requestType, baseUrl) {
        var _this = this;
        try {
            [].slice.apply(document.querySelectorAll(cssSelector)).forEach(function (element) { return __awaiter(_this, void 0, void 0, function () {
                var url, _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            url = baseUrl + element.getAttribute('data-url');
                            _a = requestType;
                            switch (_a) {
                                case 'json': return [3, 1];
                                case 'jsonp': return [3, 3];
                            }
                            return [3, 5];
                        case 1:
                            _b = element;
                            return [4, this.getHtml(url)];
                        case 2:
                            _b.innerHTML = _d.sent();
                            this.runScripts(element);
                            return [3, 5];
                        case 3:
                            _c = element;
                            return [4, this.getHtmlFromJsonp(url)];
                        case 4:
                            _c.innerHTML = _d.sent();
                            this.runScripts(element);
                            return [3, 5];
                        case 5: return [2];
                    }
                });
            }); });
        }
        catch (e) {
        }
    }
    OEmbedLoader.prototype.runScripts = function (element) {
        [].slice.apply(element.querySelectorAll('script')).forEach(function (script) {
            var scriptEl = document.createElement('script');
            scriptEl.addEventListener('load', function () {
                console.log('Run external script', script.src);
            });
            scriptEl.async = true;
            scriptEl.src = script.src;
            document.body.appendChild(scriptEl);
        });
    };
    OEmbedLoader.prototype.getHtml = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, fetch(url, {
                            cache: 'no-cache',
                            credentials: 'include'
                        })
                            .then(function (r) { return r.json(); })
                            .then(function (json) { return json.html; })];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    OEmbedLoader.prototype.getHtmlFromJsonp = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, fetchJsonp(url + ("&_=" + +new Date()))
                            .then(function (r) { return r.json(); })
                            .then(function (json) { return json.html; })];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    return OEmbedLoader;
}());
exports.OEmbedLoader = OEmbedLoader;
